import "core-js/modules/es6.array.fill";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
import lineChart from '@/components/bigDataChart/lineChart';
import { queryCurveAnalysisSx, queryElectricity } from '@/api/api';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'waterLineChart',
  mixins: [GetSiteIdMixin],
  props: {
    width: {
      type: String,
      default: '80vw'
    },
    height: {
      type: String,
      default: '590px'
    },
    reportType: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    initNum: {
      type: Number,
      default: 0
    },
    factorCategory: {
      type: String,
      default: '11'
    },
    factorCode: {
      type: String,
      default: ''
    },
    queryElectricity: {
      type: Function,
      default: null
    }
  },
  components: {
    lineChart: lineChart
  },
  methods: {
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList(reportType) {
      if (!this.$refs.chart1) return;

      if (!this.startTime || !this.endTime) {
        this.$message.error('请选择时间');
        return;
      }

      var that = this;
      var params = {
        stime: this.startTime,
        etime: this.endTime,
        id: window.sessionStorage.getItem('siteId') || '',
        type: reportType,
        factorCategory: this.factorCategory
      };

      if (this.factorCategory == '13') {
        params = {
          stime: this.startTime,
          etime: this.endTime,
          id: window.sessionStorage.getItem('siteId') || '',
          type: reportType,
          factorCode: this.factorCode
        };
      }

      queryCurveAnalysisSx(params).then(function (res) {
        if (res.success) {
          var data = {
            seriesData: [],
            xData: [],
            legendData: []
          };
          res.result.data.forEach(function (v, i) {
            data.xData.push(v.dateStr);
          });
          var dataList = new Array(res.result.factors.length).fill([]);
          dataList.forEach(function (item, index) {
            var ary1 = [];
            res.result.data.forEach(function (v, i) {
              // console.log(v.dataCodeMap[res.result.factors[index].code])
              if (v.dataCodeMap[res.result.factors[index].code]) {
                ary1.push(v.dataCodeMap[res.result.factors[index].code].value);
              }
            });
            dataList[index] = [].concat(ary1);
          });
          res.result.factors.forEach(function (v, i) {
            data.legendData.push(v.title);
            data.seriesData.push({
              name: v.title,
              data: dataList[i],
              // areaStyle: {},
              type: 'line'
            });
          });
          console.log(data, 'data');
          that.$refs.chart1.initLineChart(data, '#000');
        }
      });
    }
  },
  watch: {
    currentSiteId: function currentSiteId() {
      var ids = this.getTreeCurrentId();
      console.log(ids);

      if (ids[0] == '1') {
        this.queryElectricity();
        this.querySewageQuotaList(this.reportType);
      }
    },
    initNum: function initNum() {
      this.querySewageQuotaList(this.reportType);
    }
  }
};